import React, { useState } from 'react';

// Picture with an initials fallback (blank/broken images are common for new accounts)
const Avatar = ({ src, name = '', size = 32 }) => {
    const [failed, setFailed] = useState(false);
    const initials = name.split(' ').filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?';
    const isPlaceholder = !src || /blank\.png$/.test(src);
    const style = { width: size, height: size, fontSize: Math.round(size * 0.38) };
    if (isPlaceholder || failed) {
        return <span className="hp-avatar hp-avatar-initials" style={style}>{initials}</span>;
    }
    return <img src={src} alt={name} className="hp-avatar" style={style} onError={() => setFailed(true)} />;
};

export default Avatar;
